import {Breadcrumb, Button, Tag} from "antd";
import {HasAccess} from "@permify/react-role";
import {useState} from "react";
import {HomeOutlined, PlusOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";
import {IconEye} from "@tabler/icons-react";
import dayjs from "dayjs";
import AddDossier from "./add";
import DataTable from "../../components/dataTable";

const statusColors = {
    submitted: "orange",
    waiting_affectation: "orange",
    in_progress: "blue",
    treated: "cyan",
    waiting_validation: "orange",
    validated: "green",
    pre_closed: "gold",
    closed: "default",
    classified: "default",
    sent: "purple",
    reject: "red",
};

const Dossiers = () => {
    const [addModal, setAddModal] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleRefresh = () => {
        setRefreshTrigger((prev) => prev + 1);
    };

    const handleAddSuccess = () => {
        setAddModal(false);
        handleRefresh();
    };

    const columns = [
        {
            key: "numero",
            dataIndex: ["infosCourrier", "numero"],
            title: "Numéro",
        },
        {
            key: "reference",
            dataIndex: ["infosCourrier", "reference"],
            title: "Référence",
        },
        {
            key: "objet",
            dataIndex: ["infosCourrier", "objet"],
            title: "Objet",
        },
        {
            key: "typeDossier",
            dataIndex: ["infosCourrier", "typeDossier", "libelle"],
            title: "Type de dossier",
        },
        {
            key: "date",
            dataIndex: ["infosCourrier", "date"],
            title: "Date d'émission du dossier",
            render: (date) =>
                date ? dayjs(date).format("DD/MM/YYYY") : "-",
        },
        {
            key: "status_ac",
            dataIndex: ["infosCourrier", "statusAcLabel"],
            title: "Statut",
            render: (statusAcLabel, record) => (
                <Tag color={statusColors[record.infosCourrier.status_ac] || "default"}>
                    {statusAcLabel}
                </Tag>
            ),
        },
        {
            key: "actions",
            title: "Actions",
            render: (record) => {
                return <div style={{
                    width: 100
                }}>
                    <HasAccess permissions="LIST_COURRIER_ARRIVE">
                        <Link to={`/dashboard/dossiers/${record.infosCourrier.code}/show`} title="Détails du dossier" >
                            <Button style={{backgroundColor: 'gray'}} type="primary" color={"success"} size={"small"}> <IconEye/> </Button>
                        </Link>
                    </HasAccess>
                </div>
            }
        }
    ];

    return (
        <>
            <HasAccess permissions="ADD_DOSSIER_ARRIVE">
                <AddDossier
                    open={addModal}
                    setOpen={setAddModal}
                    onSuccess={handleAddSuccess}
                />
            </HasAccess>

            <div className="flex flex-row mt-8">
                <Breadcrumb>
                    <Breadcrumb.Item href="/">
                        <HomeOutlined />
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        Dossiers
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className="ml-auto">
                    <HasAccess permissions="ADD_DOSSIER_ARRIVE">
                        <Button
                            icon={<PlusOutlined />}
                            onClick={() => setAddModal(true)}
                            type="primary"
                        >
                            Soumettre un dossier
                        </Button>
                    </HasAccess>
                </div>
            </div>

            <DataTable
                url="dossiers"
                columns={columns}
                refreshTrigger={refreshTrigger}
            />
        </>
    );
};

export default Dossiers;
